// extracted by mini-css-extract-plugin
export var active = "_hg-2";
export var recordingDot = "_hg-1";
export var recordingIndicator = "_hg-0";